import Duck from 'extensible-duck';
import Immutable from 'immutable';
import requestsManagerAxios from '../../lib/requestsManagerAxios';

export default new Duck({
  namespace: 'public',
  store: 'contactInfo',
  types: [
    'UPDATE_CONTACT_INFO',
    'UPDATE_CONTACT_INFO_PENDING',
    'UPDATE_CONTACT_INFO_REJECTED',
    'UPDATE_CONTACT_INFO_FULFILLED',
  ],
  initialState: Immutable.fromJS({
    additionalInfo: '',
  }),
  reducer: ($$state, { type, payload, _meta }, { types }) => {
    switch (type) {
      case types.UPDATE_CONTACT_INFO_FULFILLED: {
        const { additional_info: additionalInfo } = payload.data;
        return $$state.merge({
          additionalInfo,
        });
      }
      default:
        return $$state;
    }
  },
  selectors: {},
  creators: ({ types }) => ({
    updateHomepageCustomContent: contact_info => ({
      type: types.UPDATE_CONTACT_INFO,
      payload: requestsManagerAxios.patch('/admin/contact_info', {
        contact_info,
      }),
    }),
  }),
});
